import { QueryClient } from '@tanstack/react-query'
import { fetchPage } from '@vangst/services/oogst/page'
import { RobotsEnum, SignUpContextEnum } from '@vangst/services/oogst/types'
import Routes from '@vangst/services/routes'
import { InferGetStaticPropsType } from 'next'
import Breadcrumbs from '../../components/navigation/Breadcrumbs'
import ClickyExplore from '../../components/navigation/ClickyExplore'
import PageHeader from '../../components/views/PageHeader'
import Meta from '../../domains/application/Meta'
import SignUpForm from '../../domains/viewer/SignUpForm'
import useAuthedRedirect from '../../domains/viewer/useAuthedRedirect'

export async function getStaticProps() {
  const queryClient = new QueryClient()
  const rawUrl = __filename.split('pages')[1]?.replace('.js', '')
  const { getPage } = await fetchPage(queryClient, { rawUrl })
  const page = {
    ...getPage,
    title: getPage?.title ?? 'Sign Up',
    subtitle:
      getPage?.subtitle ??
      'Join the cannabis industry’s #1 job platform today to finish your cannabis job search and get hired. Start your career journey now. ',
  }
  const crumbs = [
    { href: Routes.INDEX, text: 'Home' },
    { href: null, text: 'Sign Up' },
  ]

  return {
    props: { crumbs, page },
    revalidate: 30,
  }
}

// -------------------------------------

type PropsType = InferGetStaticPropsType<typeof getStaticProps>

export default function SignUpPage(props: PropsType) {
  useAuthedRedirect()
  const { crumbs, page } = props

  return (
    <>
      <Meta
        key="meta"
        canonicalUrl={page.metaInfo?.canonicalUrl}
        crumbs={crumbs}
        description={page.metaInfo?.description}
        image={page.pagePhotos?.[0]?.url}
        publishDate={page.postedAt}
        robots={page.metaInfo?.robots ?? RobotsEnum.IndexFollow}
        title="Sign Up for Cannabis Industry Jobs, Education, Reports and Information | Vangst"
      />
      <Breadcrumbs crumbs={crumbs} />
      <article className="mood-white">
        <PageHeader
          accent="text-white"
          className="mood-green-white"
          icon="people"
          title={page.title}
          subtitle={page.subtitle}
          description={page.description}
          imgAlt={page.pagePhotos?.[0]?.alt}
          imgSrc={page.pagePhotos?.[0]?.url}
        />
        <div className="contain-c template-content-aside">
          <section className="contain-xy flex max-w-prose flex-col gap-8 md:ml-24">
            <SignUpForm from={SignUpContextEnum.MemberSignUpForm} />
          </section>
          <aside className="contain-xy flow-y-sm mood-white sm:gap-8">
            <h2 className="heading-sm">Need a company account?</h2>
            <p>Are you a cannabis business looking to hire?</p>
            <ClickyExplore
              as="text-icon"
              className="max-w-72"
              href={Routes.SIGN_UP_COMPANY}
            >
              Register Your Business
            </ClickyExplore>
          </aside>
        </div>
      </article>
    </>
  )
}
